<template>
  <div class="table-group">
    <div class="group-title flex flex-y-center flex-x-between">
      <div>
        <span>原材料</span>
        <span v-if="isOut">(</span>
        <span v-if="isOut" class="c-green">外部来料</span>
        <span v-if="isOut">)</span>
      </div>
      <div class="m-r-20">
        <el-link type="primary" @click="batchPurchase">批量采购申请单</el-link>
      </div>
    </div>
    <vxe-grid
      :min-height="tableConfig.minHeight"
      :footer-method="tableFooterMethod"
      :columns="tableColumn"
      :data="list"
      :show-footer="!!list.length"
    >
      <!-- slot_default -->
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
      </template>
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image :list.sync="row.list_gong_cheng_tu" disabled />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file :list.sync="row.list_yuan_wen_jian" disabled />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_mu_ban" disabled />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_bao_gao" disabled />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex">
          <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemPurchase(row)">采购申请单</el-link>
      </template>
    </vxe-grid>

    <!-- 弹窗-采购申请 -->
    <PopupApplyPurchase
      v-if="isShowPopupApplyPurchase"
      :show.sync="isShowPopupApplyPurchase"
      :list="activeBatchList"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupApplyPurchase: () => import('@/views/new/purchase/apply/common/popup-do')
  },
  props: {
    isOut: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      jin_du_list: ['待采购', '采购中', '已入库'],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 63
        },
        {
          title: '原料图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '原料名称',
          field: 'name',
          width: 144
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark'
        },
        {
          title: '操作',
          width: 120,
          slots: { default: 'default_operate' }
        }
      ],
      isShowPopupApplyPurchase: false,
      activeBatchList: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig)
      return result
    }
  },
  methods: {
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    // 批量采购申请单
    batchPurchase() {
      this.isShowPopupApplyPurchase = true
      this.activeBatchList = this.list.map((item) => {
        return {
          ...item,
          bill_code: this.code
        }
      })
    },
    // 采购申请单
    itemPurchase(row) {
      this.isShowPopupApplyPurchase = true
      let obj = { ...this.$util.deepCopy(row), bill_code: this.code }
      this.activeBatchList = [obj]
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
  margin-bottom: 15px;
}
</style>
